<template>
  <div class="page--consolidated-report" :style="`min-height: ${height}px`">
    <Header :status="currentStatus" pageType="list" @exportNewReport="exportNewReport" />

    <Table
      :items="reports"
      :status="currentStatus"
      @getReports="getConsolidatedReports"
      @downloadReportById="downloadReportById"
    />
  </div>
</template>

<script>
import {
  STATUS_IS_LOADING,
  STATUS_SUCCESS,
  STATUS_FAILED
} from 'utils/constants'
import { mapActions } from 'vuex'
import Header from 'components/reports/consolidated/Header'
import Table from 'components/reports/consolidated/Table'

export default {
  name: 'ConsolidatedReportsPage',
  components: {
    Header,
    Table
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight - 64
    }
  },
  data () {
    return {
      currentStatus: STATUS_SUCCESS,
      reports: []
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    exportNewReport () {
      this.$router.push({ name: 'ConsolidatedReport' })
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    async getConsolidatedReports () {
      this.currentStatus = STATUS_IS_LOADING
      try {
        const { data: res } = await this.$apiService.getConsolidatedReports()
        this.reports = res.data
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR ', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    async downloadReportById (id, fileName = 'relatorio-agendado') {
      try {
        const {
          data: res
        } = await this.$apiService.downloadConsolidatedReportById(id)

        this.createHiddenElement(res.reportBody.url, fileName)
      } catch (err) {
        console.log('ERROR ', err)
        this.errorAlert(this.$t('Messages.genericError'))
      }
    },

    createHiddenElement (url, fileName, target = '_blank') {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = url
      hiddenElement.target = target
      hiddenElement.download = fileName
      hiddenElement.click()
    },

    autoDownloadReport () {
      if (this.routeParams.action && this.routeParams.id) {
        const fileData = JSON.parse(atob(this.routeParams.id))
        this.downloadReportById(fileData.id, fileData.fileName)
      }
    }
  },
  beforeMount () {
    this.getConsolidatedReports()
  },
  mounted () {
    this.autoDownloadReport()
  }
}
</script>
